module.exports = "<a>{{match.model.suburb}} {{match.model.postCode}}, {{match.model.state}}</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/postcode/postcode-autocomplete-template.html
// module id = 185
// module chunks = 0